import Axios from 'axios';
import { dynamicParameter } from './service/mixin-service';
import _ from 'lodash';

const defaultGetData = () => response => response.data.map(item => {
  var data = item
  data.uuid = item.id
  return data
});
const getTotalHits = response => response.data.totalHits;

const defaultParams = () => { };

export default function lazyLoading(path, params = defaultParams, itemsPerLoad = 50, getData = defaultGetData) {
  const getPath = dynamicParameter(path);
  const getParams = dynamicParameter(params);
  const getGetData = dynamicParameter(getData)

  return {
    data() {
      return {
        totalHits: 0,
        lazyItems: [],
        isLoading: false,
        hasQueuedRequest: false,
      }
    },
    methods: {
      load(params, page, size) {
        this.isLoading = true;
        return Axios.get(`/v1/${getPath(this)}`, { params: { ...params, page, size } })
          .then(response => { this.isLoading = false; return response }, () => this.isLoading = false);
      },
      loadNextData() {
        if (!this.isLoading) {
          return this.load(this.$_params, this.$_nextPage, itemsPerLoad)
            .then(response => {
              getGetData(this)(response).forEach(item => this.lazyItems.push(item));
              return response;
            });
        }
      },
      reload() {
        if (!this.isLoading) {
          this.load(this.$_params, 0, itemsPerLoad).then(response => {
            this.lazyItems = getGetData(this)(response);
            this.totalHits = getTotalHits(response);
            if (this.hasQueuedRequest) {
              this.hasQueuedRequest = false;
              this.reload();
            }
          });
        }
        else this.hasQueuedRequest = true;
      }
    },
    computed: {
      $_nextPage() {
        return (
          itemsPerLoad &&
          Math.ceil(this.lazyItems.length / itemsPerLoad)
        );
      },
      $_params() {
        return getParams(this);
      }
    },
    watch: {
      $_params(newValue, oldValue) {
        if (!_.isEqual(newValue, oldValue)) {
          if (!this.isLoading) this.reload();
          else this.hasQueuedRequest = true;
        }
      }
    }
  }
}